export default "__VITE_ASSET__DtN6F0e0__"